import React, { useState } from 'react';
import Layout from '../Layout/Layout';
import MyProfile from './MyProfile';
import MyCredits from './MyCredits';
import MyInvites from './MyInvites';
import MyOrders from './MyOrders';
import MySubscriptions from './MySubscriptions';
import { useI18n } from '../../contexts/I18nContext';
import './PersonalCenter.scss';

const PersonalCenter = () => {
  const { t } = useI18n();
  const [activeTab, setActiveTab] = useState('profile');

  const tabs = [
    { id: 'profile', label: t('personalCenter.myProfile.title'), component: MyProfile },
    { id: 'credits', label: t('personalCenter.myCredits'), component: MyCredits },
    { id: 'subscriptions', label: t('personalCenter.mySubscriptions.title'), component: MySubscriptions },
    { id: 'invites', label: t('personalCenter.myInvites'), component: MyInvites },
    { id: 'orders', label: t('personalCenter.myOrders'), component: MyOrders }
  ];

  const renderActiveComponent = () => {
    const activeTabData = tabs.find(tab => tab.id === activeTab);
    if (activeTabData) {
      const Component = activeTabData.component;
      return <Component />;
    }
    return null;
  };

  return (
    <Layout>
      <div className="personal-center">
        <div className="personal-center-container">
          {/* Page Header */}
          <div className="page-header">
            <h1>{t('personalCenter.title')}</h1>
            <p>{t('personalCenter.subtitle')}</p>
          </div>

          {/* Tab Navigation */}
          <div className="tab-navigation">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div className="tab-content">
            {renderActiveComponent()}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default PersonalCenter;